module.exports = __webpack_public_path__ + "media/bootstrap-icons/trophy-469d31ec.svg";